import React from "react";

import soaringRevenue from '../../assets/bannerImages/soaringRevenue.webp'
import { Link } from "react-router-dom";

export default function BlogPost(){
    
    return (
        <div className="blog-post">
            <BlogPostHead/>
            <BPR1/>
            <BPR2/>
            <BPR3/>
            <BPR4/>
            <BPR5/>
        </div>
    )
}

function BPR1(){
    return(
        <div className="bpr1">
            <img loading="lazy" src={soaringRevenue} alt="main-img" className="main-img"/>
        </div>
    )
}

function BPR2() {
    return (
        <div className="bpr2">
            <h2 className="main-title head">Digital Marketing: Your Business's Path to Growth</h2>
            <div className="date-box"><span class="material-symbols-outlined">calendar_month</span><p>Aug 25th, 2025</p></div>
            <p className="main-content">In today's competitive landscape, simply having a great product isn't enough to stand out. Businesses of all sizes need a clear and strategic way to connect with their audience online. Digital marketing is the process of using online channels to reach new customers, build your brand, and drive sales. It's the essential engine that powers your business's online growth, ensuring you're visible and relevant in a world where your customers spend most of their time. At Bixian Performance Marketing, we believe a smart digital strategy is the key to unlocking your full potential.</p>
        </div>
    )
}

function BPR3() {
    return (
        <div className="bpr3">
            <img loading="lazy" className="blog-post-lower-img" src={soaringRevenue} alt="blog-post-lower-img-bixian-performance-marketing"/>
            <img loading="lazy" className="blog-post-lower-img" src={soaringRevenue} alt="blog-post-lower-img-bixian-performance-marketing"/>
        </div>
    )
}

function BPR4() {
    return (
        <div className="bpr4">
            <h3 className="head">Why a Digital Strategy is Essential</h3>
            <p>Digital marketing helps you establish a strong online presence, making your brand accessible 24/7. It allows you to precisely target your ideal customers and provides measurable data on what works, giving you a clear return on investment.</p>
        </div>
    )
}

function BPR5() {
    return (
        <div className="bpr5">
            <h3 className="head">Our Approach to Online Growth</h3>
            <p>Bixian Performance Marketing helps you navigate this complex world by crafting engaging digital experiences. We work to build your brand's authority, from strategic paid ads and intuitive websites to compelling content that connects emotionally with your audience.</p>
        </div>
    )
}

function BlogPostHead(){
    return(
        <div className="blog-post-head">
            <Link to='/blog-post'><h1 className="current">Blog Post</h1></Link>
            <Link to='/blog-post-two'><h1>Blog Post 2</h1></Link>
            <Link to='/blog-post-three'><h1>Blog Post 3</h1></Link>
        </div>
    )
}